<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择检验项"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="inspectionItems">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="关键字">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="no" align="center" label="检验编号"/>
      <el-table-column prop="name" align="center" label="检验名称"/>
      <el-table-column prop="inspectionCategory" align="center" label="类别"/>
      <el-table-column prop="inspectionStandard" align="center" label="检验标准"/>
      <el-table-column prop="standardValue" align="center" label="标准值"/>
      <el-table-column prop="minValue" align="center" label="最小值"/>
      <el-table-column prop="maxValue" align="center" label="最大值"/>
      <el-table-column prop="unit" align="center" label="单位"/>
      <el-table-column prop="note" align="center" label="备注"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    components: {VmTable, VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        filter: {
          filter: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
